import React from "react";
import heroImage from "../assets/hero.png"; // Replace with your image
import "./Hero.css";
import "../styles/main.css"; // Optional for custom styling

function Hero() {
  return (
    <section className="hero-section container-fluid py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Text content */}
          <div className="col-12 col-md-6 hero-text mb-4 mb-md-0 text-center text-md-start">
            <h1 className="hero-title">EZ MedServ</h1>
            <h3 className="hero-subtitle">Multi-Sector Solutions. One Trusted Partner.</h3>
            <p className="hero-description">
              Welcome to EZ MedServ, where businesses across industries find the support they need to thrive.<br/><br/>
              We are more than a service provider. we are a strategic partner for companies in banking, food, entertainment, healthcare, technology, retail, and beyond.<br/><br/>
              In today’s world, every sector needs reliable customer service, technology solutions, consulting expertise, and operational support. At EZ MedServ, we bring all these together under one roof, helping businesses simplify operations, cut costs, and deliver better experiences.
            </p>
            <div className="hero-buttons mt-3 d-flex flex-nowrap justify-content-center justify-content-md-start align-items-center align-items-md-start gap-3">
              <a href="#contact" className="btn btn-primary me-3">
                <i className="fas fa-file-signature"></i> Get Free Quote
              </a>
              <a href="tel:+16147066175" className="btn btn-outline-primary">
                <i className="fas fa-phone-alt"></i> 1 (614) 706-6175
              </a>
            </div>
          </div>

          {/* Image content */}
          <div className="col-12 col-md-6 text-center">
            <img src={heroImage} alt="Hero" className="hero-img img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;